// Tab1.js
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import React from "react";
import { useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CancelIcon from "@mui/icons-material/Cancel";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import { useEffect, useRef } from "react";
import {
  Card,
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
} from "@mui/material";
import Drawer from "@mui/material/Drawer";
import { ButtonGroup } from "@mui/material";
import { DialogContentText } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import {
  createPackage,
  retrievePackage,
  AutocompletePackage,
  UpdateMemberPackage,
  DeletePackage,
  StatusMemberPackage,
} from "../Apihelper/ApiHelper";
import json2mq from "json2mq";
import Stack from "@mui/material/Stack";
import AppToast from '../../components/Toast/AppToast';
import ListPagination, { pickTotal } from "../../components/ListPagination/ListPagination";

const MembershipPackage = (props) => {
  const { colors: appColors } = useAppTheme();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const searchRef = useRef("");
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Default to 'success'
  const [fetchdatarow, setetchdatarow] = useState([]); // Default to 'success'
  const [index, setIndex] = useState(0);
  const [field1, setField1] = useState("");
  const [localrole] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("userdata"))?.role || "";
    } catch {
      return "";
    }
  });

  const [field2, setField2] = useState("");
  const [field3, setField3] = useState("");
  const [field4, setField4] = useState("");
  const [loading, setLoading] = useState(false);
  // Function to handle Snackbar opening
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };

  const [editItem, setEditItem] = useState({});
  const [modalMode, setModalMode] = useState("");
  //  modalMode
  const handleEditModalOpen = (
    id,
    name,
    duration,
    packageAmount,
    admissionValue
  ) => {
    setModalMode("edit");
    setEditItem({
      id: id,
      name: name,
      duration: duration,
      packageAmount: packageAmount,
      admissionValue: admissionValue,
    });
    // console.log(admissionValue);
    setField(id);
    setField1(name || "");
    setField2(duration || "");
    setField3(packageAmount || "");
    setField4(admissionValue || "");
    setaddmodalopen(true); // Open the edit modal
  };

  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [addmodalopen, setaddmodalopen] = useState(false);
  const [field, setField] = useState("");

  const [status, setstatus] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const handleToggle = (id, status) => {
    setOpenConfirmation(true);
    const newStatus = status === 1 ? 0 : 1;
    setstatus(newStatus);
    setDeleteConfirmationId(id);
    setIsActive(newStatus === 0);
  };

  const handleConfirm = async () => {
    // setIsActive(!isActive);
    // setOpenConfirmation(false);

    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;

      const res = await StatusMemberPackage(
        userToken,
        userId,
        status,
        deleteConfirmationId
      );

      if (res.code == "200") {
        handleSnackbarOpen(res.message, "success");
        setIsActive(!isActive);
        setOpenConfirmation(false);
        setOpenDeleteConfirmation(false);
        fetchData(undefined, page);
      } else {
        handleSnackbarOpen(res.message, "error");
        //  console.error(error); // Handle error
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };

  const handleCancel = () => {
    setOpenConfirmation(false);
  };

  const handleaddOpen = () => {
    setModalMode("add");
    setaddmodalopen(true);
  };
  const [formSubmitted, setFormSubmitted] = useState(false);
  const handleaddClose = () => {
    setField1("");
    setField2("");
    setField3("");
    setField4("");
    setFormSubmitted(false);
    setaddmodalopen(false);
  };

  const handleAddNew = () => {
    console.log("Adding new item:", field1, field2, field3);

    handleaddClose();
  };
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );

  const handleDelete = (id) => {
    handleClose();
    setDeleteConfirmationId(id);
    setOpenDeleteConfirmation(true, id);
  };

  const handleConfirmDelete = async (id) => {
    // setSnackbarMessage('package deleted successfully');
    // setSnackbarSeverity('error');
    // setOpenDeleteConfirmation(false);
    // setOpenToast(true); // Show toast message

    if (deleteConfirmationId !== null) {
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id;

        const res = await DeletePackage(
          userToken,
          userId,
          deleteConfirmationId
        );

        if (res.code == "200") {
          handleSnackbarOpen(res.message, "success");
          setOpenDeleteConfirmation(false);
          fetchData(undefined, page);
        } else {
          handleSnackbarOpen(res.message, "error");
          //  console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error);
        // Handle errors
      }
    }
  };

  const handleCancelDelete = () => {
    setOpenDeleteConfirmation(false);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };

  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubmit = async () => {
    setFormSubmitted(true)
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    if (!field1 || !field2 || !field3 ) {
     
      return; // Stop submission if validation fails
    }
    if (modalMode === "add") {
      try {
        const res = await createPackage(
          userToken,
          field1,
          field2,
          field3,
          1000
        );
        if (res.code == "200") {
          setField1("");
          setField2("");
          setField3("");
          setField4("");

          handleSnackbarOpen(res.message, "success");
          fetchData(undefined, page);
        } else {
          handleSnackbarOpen(res.message, "error");
          //   console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error); // Handle error
      }
    } else if (modalMode === "edit") {
      try {
        if (editItem) {
          const { id, name, duration, packageAmount, admissionValue } =
            editItem;

          const res = await UpdateMemberPackage(
            id,
            userToken,
            field1,
            field2,
            field3,
            field4
          );
          if (res.code == "200") {
            setField1("");
            setField2("");
            setField3("");
            setField4("");

            handleSnackbarOpen(res.message, "success");
            fetchData(undefined, page);
          } else {
            handleSnackbarOpen(res.message, "error");
            //   console.error(error); // Handle error
          }
        }
      } catch (error) {
        console.error(error); // Handle error
      }
    }

    // Close the modal after submission
    handleaddClose();
  };
  // Fetch one page. A new search starts at page 0; pass the page to stay where you are.
  const fetchData = async (value, pageZero = 0, size = rowsPerPage) => {
    if (value !== undefined) searchRef.current = value || "";
    setLoading(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await retrievePackage(userToken, userId, searchRef.current, size, pageZero * size);

      if (res.code == "200") {
        const rows = Array.isArray(res.load_data) ? res.load_data : [];
        // The last row of the last page was just removed: step back one page.
        if (rows.length === 0 && pageZero > 0) {
          await fetchData(undefined, pageZero - 1, size);
          return;
        }
        setetchdatarow(rows);
        setPage(pageZero);
        const total = pickTotal(res);
        setTotalCount(total != null ? total : pageZero * size + rows.length);
      } else {
        setetchdatarow([]);
        setTotalCount(0);
        setPage(0);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSearchChange = (event, value) => {
    const searchText = value || ""; // If value is undefined or empty, set searchText to empty string
    // setSearchText(searchText);
    // Call fetchData function here with the updated searchText
    fetchData(searchText);
  };

  const handleInputChange = async (value) => {
    if (value.length >= 3) {
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; // Assuming you have a userId in userdata
        const searchText = value; // Example search text

        const res = await AutocompletePackage(userToken, userId, searchText);

        if (res.code == "200") {
          const names = res.data.map((item) => item.name);
          setOptions(names);
        } else {
          handleSnackbarOpen(res.message, "error");
          //  console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error);
        // Handle errors
      }
    }
  };
  React.useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      // User is not logged in, no need to redirect
      navigate('/');
    }
    
  }, []);
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 2, sm: 0 }
      }}>
        <Box sx={{ width: { xs: '100%', sm: '300px' } }}>
          <Autocomplete
            freeSolo
            options={options}
            onInputChange={(event, value) => handleInputChange(value)}
            onChange={(event, value) => handleSearchChange(event, value)}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                placeholder="Search packages..."
                sx={{
                  width: '100%',
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: appColors.evergreen },
                    '&.Mui-focused fieldset': { borderColor: appColors.evergreen }
                  }
                }}
              />
            )}
          />
        </Box>
        {localrole === 'admin' && (
        <Button
          variant="contained"
          onClick={handleaddOpen}
          startIcon={<ControlPointIcon />}
          sx={{
            bgcolor: appColors.evergreen,
            '&:hover': { bgcolor: appColors.pine },
            textTransform: 'none',
            fontWeight: 600,
            width: { xs: '100%', sm: 'auto' }
          }}
        >
          Add Package
        </Button>
        )}
      </Box>

      <TableContainer 
        component={Paper} 
        sx={{ 
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          borderRadius: 2,
          overflow: 'auto'
        }}
      >
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress sx={{ color: appColors.evergreen }} />
          </Box>
        ) : (
          <Table sx={{ minWidth: { xs: 650, sm: 750 } }} size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: appColors.evergreen }}>
                <TableCell sx={{ color: 'white', fontWeight: 600, whiteSpace: 'nowrap' }}>Package Name</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 600, whiteSpace: 'nowrap' }}>Duration (Days)</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 600, whiteSpace: 'nowrap' }}>Total Value</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 600, whiteSpace: 'nowrap' }}>Status</TableCell>
                {localrole === 'admin' && (
                  <TableCell sx={{ color: 'white', fontWeight: 600, whiteSpace: 'nowrap' }}>Actions</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {fetchdatarow.map((row, index) => (
                <TableRow 
                  key={index}
                  sx={{
                    '&:nth-of-type(odd)': { bgcolor: '#f9fafb' },
                    '&:hover': { bgcolor: '#f3f4f6' }
                  }}
                >
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.name}</TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.duration}</TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.package_amount}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      size="small"
                      disabled={localrole !== 'admin'}
                      onClick={() => handleToggle(row.id, row.status)}
                      sx={{
                        bgcolor: row.status === 1 ? appColors.evergreen : '#dc2626',
                        '&:hover': {
                          bgcolor: row.status === 1 ? appColors.pine : '#b91c1c'
                        },
                        textTransform: 'none',
                        fontWeight: 600,
                        minWidth: '90px',
                        '&.Mui-disabled': {
                          bgcolor: row.status === 1 ? appColors.evergreen : '#dc2626',
                          color: 'white',
                          opacity: 0.6,
                        },
                      }}
                    >
                      {row.status === 1 ? 'Active' : 'Inactive'}
                    </Button>
                  </TableCell>
                  {localrole === 'admin' && (
                  <TableCell>
                    <ButtonGroup size="small" aria-label="action buttons">
                      <Button
                        onClick={() =>
                          handleEditModalOpen(
                            row.id,
                            row.name,
                            row.duration,
                            row.package_amount,
                            row.admission_value
                          )
                        }
                        sx={{
                          color: appColors.evergreen,
                          borderColor: appColors.evergreen,
                          '&:hover': {
                            bgcolor: 'rgba(31, 122, 84, 0.04)',
                            borderColor: appColors.pine
                          }
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </Button>
                      <Button
                        onClick={() => handleDelete(row.id)}
                        sx={{
                          color: '#dc2626',
                          borderColor: '#dc2626',
                          '&:hover': {
                            bgcolor: 'rgba(220, 38, 38, 0.04)',
                            borderColor: '#b91c1c'
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </Button>
                    </ButtonGroup>
                  </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
      <ListPagination
        count={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(p) => fetchData(undefined, p)}
        onRowsPerPageChange={(size) => { setRowsPerPage(size); fetchData(undefined, 0, size); }}
      />

      {/* Add/Edit Modal */}
      <Dialog 
        open={addmodalopen} 
        onClose={handleaddClose}
        maxWidth="xs"
      >
        <DialogTitle sx={{ 
          borderBottom: 1,
          borderColor: 'divider',
          mb: 2
        }}>
          {modalMode === "add" ? "Add Membership Package" : "Edit Membership Package"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            fullWidth
            type="text"
            value={field1}
            error={formSubmitted && !field1}
            helperText={formSubmitted && !field1 ? "Name is required" : ""}
            onChange={(e) => setField1(e.target.value.toUpperCase())}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: appColors.evergreen },
                '&.Mui-focused fieldset': { borderColor: appColors.evergreen }
              },
              '& .MuiInputLabel-root.Mui-focused': { color: appColors.evergreen }
            }}
          />
          <TextField
            margin="dense"
            label="Duration (Days)"
            fullWidth
            type="number"
            value={field2}
            error={formSubmitted && !field2}
            helperText={formSubmitted && !field2 ? "Duration is required" : ""}
            inputProps={{ min: 0 }}
            onChange={(e) => setField2(e.target.value)}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: appColors.evergreen },
                '&.Mui-focused fieldset': { borderColor: appColors.evergreen }
              },
              '& .MuiInputLabel-root.Mui-focused': { color: appColors.evergreen }
            }}
          />
          <TextField
            margin="dense"
            label="Total Value"
            fullWidth
            type="number"
            value={field3}
            error={formSubmitted && !field3}
            helperText={formSubmitted && !field3 ? "Total Value is required" : ""}
            onChange={(e) => setField3(e.target.value)}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: appColors.evergreen },
                '&.Mui-focused fieldset': { borderColor: appColors.evergreen }
              },
              '& .MuiInputLabel-root.Mui-focused': { color: appColors.evergreen }
            }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={handleaddClose}
            startIcon={<CancelIcon />}
            sx={{
              color: appColors.evergreen,
              '&:hover': { bgcolor: 'rgba(31, 122, 84, 0.04)' },
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            startIcon={<CheckCircleIcon />}
            sx={{
              bgcolor: appColors.evergreen,
              '&:hover': { bgcolor: appColors.pine },
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            {modalMode === "add" ? "Submit" : "Update"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteConfirmation}
        onClose={handleCancelDelete}
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }
        }}
      >
        <DialogTitle>Delete Package</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this package?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={handleCancelDelete}
            startIcon={<CancelIcon />}
            sx={{
              color: appColors.evergreen,
              '&:hover': { bgcolor: 'rgba(31, 122, 84, 0.04)' },
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            color="error"
            startIcon={<DeleteIcon />}
            sx={{
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Status Toggle Confirmation Dialog */}
      <Dialog
        open={openConfirmation}
        onClose={handleCancel}
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }
        }}
      >
        <DialogTitle>{isActive ? "Deactivate Package" : "Activate Package"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to {isActive ? "deactivate" : "activate"} this package?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={handleCancel}
            startIcon={<CancelIcon />}
            sx={{
              color: appColors.evergreen,
              '&:hover': { bgcolor: 'rgba(31, 122, 84, 0.04)' },
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            startIcon={<CheckCircleIcon />}
            sx={{
              bgcolor: appColors.evergreen,
              '&:hover': { bgcolor: appColors.pine },
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Toast/Snackbar */}
      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
    </Box>
  );
};

export default MembershipPackage;